/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ conversation: NonNullable<unknown> }} Notifications_Message_Received_TitleInputs */

const en_notifications_message_received_title = /** @type {(inputs: Notifications_Message_Received_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New message: ${i?.conversation}`)
};

const pt_br2_notifications_message_received_title = /** @type {(inputs: Notifications_Message_Received_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nova mensagem: ${i?.conversation}`)
};

/**
* | output |
* | --- |
* | "New message: {conversation}" |
*
* @param {Notifications_Message_Received_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_message_received_title = /** @type {((inputs: Notifications_Message_Received_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Received_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_message_received_title(inputs)
	return pt_br2_notifications_message_received_title(inputs)
});